import React, { createContext, useContext, ReactNode, useState } from 'react';

interface AppContextProps {
  pageHeaderText: string;
  setPageHeaderText: (headerSuffix: string) => void;
  breadcrumbProjectLabel?: string;
  setBreadcrumbProjectLabel: (label: string | undefined) => void;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

interface AppContextProviderProps {
  children: ReactNode;
}

const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  const [pageHeaderText, setPageHeaderText] = useState('');
  const [breadcrumbProjectLabel, setBreadcrumbProjectLabelState] = useState<string | undefined>(undefined);

  const setBreadcrumbProjectLabel = (label: string | undefined) => {
    setBreadcrumbProjectLabelState(label || undefined);
  };

  const contextValue: AppContextProps = {
    pageHeaderText,
    setPageHeaderText,
    breadcrumbProjectLabel,
    setBreadcrumbProjectLabel,
  };

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

const useAppContext = (): AppContextProps => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within a AppContextProvider');
  }
  return context;
};

export { AppContextProvider, useAppContext };
